<template>
    <options-menu
    :title="containerTitle"
    :container-name="containerName"
    :options="options"
    :table-params="tableParams"
    :show-checkbox="false"
    :show-folder="false"
    ref="menu"
    ></options-menu>

</template>

<script setup>
  import { reactive, onMounted, watch, ref, getCurrentInstance } from 'vue';
  import OptionsMenu from './../OptionsMenu/OptionsMenu.vue';
  //import { deviceStore } from './../../../stores/deviceStore';
  import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';


  //const store = deviceStore();
  const store = window.devStore;

  const props = defineProps({
    viewportID: String
  });

  let storeViewport = ref({}), client = ref({});

  onMounted(()=>{
    console.log('onMounted', 'ID:', props.viewportID);
    setViewport(props.viewportID);
    console.log('onMounted', 'setViewport - done');
   // window.rightMenu = getCurrentInstance();

  });

  function setViewport (viewportID){
    console.log('setViewport:', store.viewPorts.find(e => (e.viewportID === viewportID) ));
    storeViewport.value = store.viewPorts.find(e => (e.viewportID === viewportID) );
    client.value = window.botStore.getClientByViewPort(viewportID);
    console.log('setViewport', 'client:', client.value);
    //window.storeViewport = storeViewport;
  }

  const options = reactive([]);
  watch(
      store.viewPorts,
      ()=>{
        //console.log('rightmenu-watch');
        //let viewport = store.viewPorts.find(e => e.viewportID === storeViewport.value.viewportID);
        setRightMenuOptions();
      },
      {
        deep: true
      }
  );

  function setRightMenuOptions() {
    //console.log('setRightMenuOptions:', 'storeViewport:', storeViewport);
    if(Array.isArray(storeViewport.value.rightMenu)) {
      //console.log('options:', options);
      options.length = 0;
      options.push(...storeViewport.value.rightMenu.map((e, i)=>{
        return {
          icon: e.icon || '',
          title: e.title,
          callback: e.callback,
          path: `${(i + '').padStart(3,'0')}`
        }
      }));
    }
  }

  const containerTitle = ref('Menu'), containerName = ref(`rootMenu${oxygenUtil.getGUID()}`),menu = ref(null);

  const tableParams = reactive({
    showCheckbox: false,
    showFolder: false,
    showRightMenu: false
  });

  function showMenu(...args) {
    menu.value.showMenuAlignedToElement(...args);
  }

  defineExpose({
    showMenu,
    storeViewport,
    options,
    menu,
    setRightMenuOptions
  });

</script>

<style scoped>

</style>